import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import LoginMutationArg from '../../types/api/auth/requests/login-mutation-arg'
import LoginResult from '../../types/api/auth/responses/login-result'

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Auth'],
    endpoints: builder => ({
        login: builder.mutation<LoginResult, LoginMutationArg>({
            query: body => ({
                url: '/auth/local',
                method: 'POST',
                body,
            }),
        }),
        // logout: builder.mutation
    }),
})

export const { useLoginMutation } = authApi
